import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonDialogSettings } from '../common-dialog-settings.interface';

@Component({
    selector: 'app-notification-dialog',
    templateUrl: './notification-dialog.component.html',
    standalone: false,
})
export class NotificationDialogComponent implements OnInit {
    public constructor(
        public dialogRef: MatDialogRef<NotificationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public settings: CommonDialogSettings
    ) {}

    public ngOnInit(): void {}
}
